import { HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class CustomInterceptorAddLadderLevel implements HttpInterceptor {

   constructor() { }

   intercept(req: HttpRequest<any>, next: HttpHandler) {

      if (req.url.includes("wifmsearch")) return next.handle(req);


      // intercept ALL http requests... every dotnet controller is looking for these
      // EXCEPT in some admin cases when we need to override ladder and level
      if (req.params.get("_ladderId") == null || req.params.get("_levelId") == null) {
         const newReq = req.clone({
            params: (req.params ? req.params : new HttpParams())
               .set('_ladderId', localStorage.getItem('ladderId'))
               .set('_levelId', localStorage.getItem('levelId') || '0')
         });
         return next.handle(newReq);
      }
      else return next.handle(req);
   }
}